/** The most a design's picture may be; mirrors maxAssetBytes in internal/api/layouts.go. */
export const MAX_PICTURE_BYTES = 20 << 20

/** Whether a picture upload would be refused for its size, checked before sending it. */
export function pictureTooBig(bytes: number): boolean {
  return bytes > MAX_PICTURE_BYTES
}
